const storageKey = venueId => `push_pending_request_${venueId}`;

// Match parseNotification on the server when identifying retries and unchanged
// drafts. Keep stored raw fingerprints compatible with earlier CMS versions.
export function notificationFingerprint(title, body, url) {
  // eslint-disable-next-line no-control-regex -- Intentionally strip the same control characters as the backend.
  const clean = text => text.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f\u202a-\u202e\u2066-\u2069]/g, '').replace(/\s+/g, ' ').trim();
  let link = url.trim();
  if (link && !(link.startsWith('/') && !link.startsWith('//') && !/[\s\\]/.test(link))) {
    try {
      const parsed = new URL(link);
      if (parsed.protocol === 'https:') link = parsed.toString();
    } catch { /* Invalid drafts retain their original link for server validation. */ }
  }
  return JSON.stringify([clean(title), clean(body), link]);
}

export function matchesNotificationFingerprint(saved, expected) {
  try {
    const parts = JSON.parse(saved);
    return Array.isArray(parts) && parts.length === 3 && parts.every(part => typeof part === 'string')
      && notificationFingerprint(...parts) === expected;
  } catch { return false; }
}

export function readPendingNotificationRequests(venueId) {
  if (!venueId) return [];
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey(venueId)) || 'null');
    // Preserve the request saved by earlier versions of the CMS.
    const entries = Array.isArray(saved) ? saved : saved ? [saved] : [];
    const ids = new Set();
    return entries.filter(entry => {
      if (!entry || typeof entry.fingerprint !== 'string' || typeof entry.requestId !== 'string'
        || !/^[a-zA-Z0-9_-]{16,100}$/.test(entry.requestId) || ids.has(entry.requestId)) return false;
      ids.add(entry.requestId);
      return true;
    }).map(({ requestId, fingerprint }) => ({ requestId, fingerprint }));
  } catch {
    return [];
  }
}

export function savePendingNotificationRequests(venueId, requests) {
  try {
    if (requests.length) sessionStorage.setItem(storageKey(venueId), JSON.stringify(requests));
    else sessionStorage.removeItem(storageKey(venueId));
  } catch {
    // In-memory request IDs still protect retries when browser storage is unavailable.
  }
}

export function pendingNotificationTitle(request) {
  try {
    const title = JSON.parse(request.fingerprint)[0];
    return typeof title === 'string' && title.trim() ? title : 'Previous notification';
  } catch {
    return 'Previous notification';
  }
}
